// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as ThemeAtom from "common/src/atoms/ThemeAtom.bs.js";
import * as Core from "@mantine/core";

function Modal0(Props) {
  var opened = Props.opened;
  var onClose = Props.onClose;
  var children = Props.children;
  var padding = Props.padding;
  var inner = Props.inner;
  var modalClassOpt = Props.modalClass;
  var innerClassOpt = Props.innerClass;
  var modalClass = modalClassOpt !== undefined ? modalClassOpt : "";
  var innerClass = innerClassOpt !== undefined ? innerClassOpt : "";
  var match = Jotai.useAtom(ThemeAtom.darkTheme);
  return React.createElement(Core.Modal, {
              opened: opened,
              withCloseButton: false,
              onClose: onClose,
              styles: {
                modal: {
                  padding: padding
                },
                inner: inner
              },
              classNames: {
                modal: modalClass + " bg-bg0",
                inner: "px-0 " + innerClass
              },
              overlayBlur: match[0] !== "midnight" ? 2 : 0,
              children: children
            });
}

var modalScrollEl = (function () {
  return document.querySelector(".mantine-Modal-inner")
});

var make = Modal0;

export {
  make ,
  modalScrollEl ,
  
}
/* jotai Not a pure module */
